import Button from "components/base/Button";
import { Text } from "components/base/Form";
import { Alert } from "components/base/Toast";
import useSendEmail from "hooks/useSendEmail";
import { useState } from "react";

const InvitationForm = ({ customer, hide }) => {
  console.log("customer", customer);

  const emails = [
    customer.user.email,
    ...customer.subAccounts.map((i) => i.user.email),
  ];

  const template = `Dear ${customer.name}.,

We hope this email finds you well. We are excited to inform you that your account has been created on Waboba business website: biz.waboba.com.

Your account is now associated with the company name "${customer.name}". All updates related to the order for this company will be informed by emails sending to your username email address.

You can login with your email address by requesting a login code on the our website.

We recommend that you log in at your earliest convenience to explore the features and functionalities of our website.

Waboba Business Website - biz.waboba.com

Our business website serves as a central hub for all your business needs. Here's a brief overview of the key features:

Product Gallery: Access high-resolution product photos for a detailed view of our offerings.

Sales Materials: Download catalogs, lifestyle images, logos, videos to support your sales efforts.

Order Tracking: Easily track the status of your orders and shipments, ensuring you stay informed about delivery timelines.

We believe that these features will enhance your experience and streamline your interactions with us.

Should you have any questions or require assistance, please feel free to reach out to our customer support team at tech@waboba.com .

Best regards,

Waboba Customer Support Team`;

  const [message, setMessage] = useState(template);
  const [send, sendRes] = useSendEmail();

  function sendHandler() {
    send({
      variables: {
        to: emails,
        subject: `Welcome to Waboba Business Website - Your Account Information`,
        message,
      },
      onCompleted() {
        Alert("success", "Invitation email sent successfully.");
        hide();
      },
    });
  }

  return (
    <div>
      <div className="flex items-center space-x-3">
        <label>Email to: </label>
        <span>{emails.join(", ")}</span>
      </div>

      <div className="-mx-[2px] mt-4">
        <Text value={message} onChange={(e) => setMessage(e.target.value)} />
      </div>

      <div className="mt-4">
        <Button
          primary
          send
          onClick={sendHandler}
          loading={sendRes.loading}
        >
          Send
        </Button>
      </div>
    </div>
  );
};

export default InvitationForm;
